//import React from 'react';
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import styled, { createGlobalStyle } from "styled-components";
import { processDomainDataLists, getDateStringFromWeek } from './DealsDataHelper';


// import { bindActionCreators } from "redux";

// import { performThumbnailSearch } from "../../actions/thumbnailActions";

import TextFieldGroup from "../common/TextFieldGroup";
import SelectCategoryGroup from "../common/SelectCategoryGroup";
import DoubleSlider from "./DoubleSlider";
import DateSlider from "./DateSlider";

import Modal from "react-responsive-modal";

const SliderDateDisplay = styled("div")`
  display: inline-block;
  height: 12px;
  width: 90%;
  margin: 0 5%;
  color:white;
  font-size:10pt;
`;

class FilterDealsBar extends Component {
  constructor(props) {
    super(props);
    //  console.log("passed in props", props.minmax);

    this.state = {
      searchterm: "",
      cat0: "",
      cat1: "",
      cat2: "",
      city: "Any",
      city_list: ["City 1", "City 2", "City 3"],
      state: "Any",
      state_list: ["State 1", "State 2", "State 3"],
      lok: "",
      lok_list: ["3", "7", "12"],
      ppn: "",
      ppn_list: ["30.33", "127.00", "150.00"],
      showhidelabel: 'hide',
      mapgridlabel: 'map',
      dofiltering: false,


      errors: {}
    };


  }


  componentDidMount() {


    // this.setState({ minmax: this.props.minmax });

    let dd = this.props.deals.domain_data;

    if (dd) {
      // this.processDomainData(dd);
      let ucities = this.props.deals.current_cities;
      let ustates = this.props.deals.current_states;
      let uppn = this.props.deals.current_lok;
      // let robj = processDomainDataLists(dd);
      this.setState({ 'city_list': ucities, 'state_list': ustates, 'ppn_list': uppn });
    }

  }



  onCityChange = (e) => {
    this.setState({ city: e.target.value, state: 'Any', lok: 'Any' });
    let obj = {};
    obj['which'] = 'city';
    obj['value'] = e.target.value;
    this.props.onFilterChange(obj);
  }
  onStateChange = (e) => {
    this.setState({ state: e.target.value, city: 'Any', lok: 'Any' });
    let obj = {};
    obj['which'] = 'state';
    obj['value'] = e.target.value;
    this.props.onFilterChange(obj);
  }
  onLOKChange = (e) => {
    this.setState({ lok: e.target.value, state: 'Any', city: 'Any' });
    let obj = {};
    obj['which'] = 'lok';
    obj['value'] = e.target.value;
    this.props.onFilterChange(obj);
  }
  // onPPNChange = (e) => {
  //   this.setState({ [e.target.name]: e.target.value });
  // }
  hidequerybar = (e) => {
    e.preventDefault();
    let qb = document.getElementById('querybar');
    if (qb.style.display === 'none') {
      qb.style.display = 'block';
      this.setState({ showhidelabel: 'hide' })
    } else {
      qb.style.display = 'none';
      this.setState({ showhidelabel: 'show' })
    }
  }

  showMap = (e) => {
    e.preventDefault();
    // let which = null
    if (this.state.mapgridlabel === 'map') {
      this.setState({ mapgridlabel: 'grid' });
    } else {
      this.setState({ mapgridlabel: 'map' });
    }
    this.props.onShowMap();
  }



  //let link = `/api/business/find-business/${bizid}`;
  render() {
    const { errors } = this.state;

    // const { minmax } = this.props;
    const { current_cities } = this.props.deals;
    const { current_states } = this.props.deals;
    const { current_lok } = this.props.deals;

    let { showhidelabel } = this.state;
    let { mapgridlabel } = this.state;

    return (
      <div className="dashboardminor"
        style={{
          width: "95%",
          paddingTop: "10px",
          paddingBottom: "0px"
        }}
      >


        <div className="row">

          <div className="col-md-1">
            <span>
              <a className="btn btn-xs btn-info"
                href="#"
                onClick={(e) => {
                  {
                    {
                      this.hidequerybar(e);
                    }
                  }
                }}
              >

                {showhidelabel}
              </a>
            </span>
          </div>
          <div className="col-md-1">
            &nbsp;
          </div>

          <div className="col-md-1">
            City
            </div>
          <div className="col-md-2">
            <div className="form-group">
              <SelectCategoryGroup
                label="City"
                name="city"
                list={current_cities}
                value={this.state.city}
                onChange={this.onCityChange}
                error={errors.city}
              />
            </div>
          </div>
          <div className="col-md-1">
            State
            </div>

          <div className="col-md-2">
            <div className="form-group">
              <SelectCategoryGroup
                label="State"
                name="state"
                list={current_states}
                value={this.state.state}
                onChange={this.onStateChange}
                error={errors.state}
              />
            </div>
          </div>
          <div className="col-md-1">
            Nights
            </div>
          <div className="col-md-2">
            <div className="form-group">
              <SelectCategoryGroup
                label="Nights"
                name="lok"
                list={current_lok}
                value={this.state.lok}
                onChange={this.onLOKChange}
                error={errors.lok}
              />
            </div>
          </div>
          <div className="col-md-1">
            <span>
              <a className="btn btn-xs btn-info"
                href="#"
                onClick={(e) => {
                  {
                    {
                      this.showMap(e);
                    }
                  }
                }}
              >
                {mapgridlabel}


              </a>
            </span>
          </div>
          {/* <div className="col-md-2">
            <div className="form-group">
              <span>PPN</span><br />
              <SelectCategoryGroup
                label="PPN"
                name="ppn"
                list={this.state.ppn_list}
                value={this.state.ppn}
                onChange={this.onPPNChange}
                error={errors.ppn}
              />
            </div>
          </div> */}






        </div>
      </div>
    );
  }
}




//export default withRouter(Advertisements);
const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
  deals: state.deals,
  // mimereducer: state.mimereducer,
});

export default connect(mapStateToProps, {

})(withRouter(FilterDealsBar));

/*

  // onChange(e) {
  //   this.setState({ searchterm: e.target.value });
  // }
  onCat0Select(e, cat) {
    let cat0list = document.getElementsByClassName("cat0nav");
    window.scrollTo(0, 0);
    for (var i = 0; i < cat0list.length; i++) {
      let el = cat0list[i];
      el.classList.remove("navpicked");
    }
    let which = e.target;
    which.classList.add("navpicked");

    e.preventDefault();
  }

  onCat1Select(e, cat1) {
    e.preventDefault();
    let fobj = {};
    fobj = { cat0: this.state.cat0, cat1: cat1 };
    // let catlist2 = list_helper.getCat2(cat1);
    // if (catlist2.length > 0) {
    //   this.setState({ cat1: cat1, cat2_list: catlist2 });
    // } else {
    //console.log("we have no cat2 list so we run ", fobj);
    //this.props.getCategoryMimes(fobj);
    // }
    //console.log(typelist2);
  }

  onCat1SelectMoreList(cat1) {
    // console.log("more list onCat1SelectMoreList ", cat1);
    // this.setState({ showmore: false });
    // this.props.getCat1Mimes(cat1);
  }

  onCat2Select(e, cat2) {
    e.preventDefault();
    let fobj = {};
    fobj = { cat0: this.state.cat0, cat1: this.state.cat1, cat2: cat2 };
    // console.log("select cat2", fobj);

    // this.props.getMimes(fobj);
  }

*/

/*

  oldprocessDomainData(dary) {
    // ddobj['query'] = { '_id': '$city' };
    // ddobj['query'] = { '_id': '$state' };
    // ddobj['query'] = { '_id': '$lok' };
    // ddobj['query'] = { '_id': '$ppn' };
    // ddobj['query'] = { '_id': '$start_date' };
    // ddobj['query'] = { '_id': '$bedrooms' };
    let tary = [];
    let cary = [];
    let sary = [];
    let lary = [];
    let pary = [];
    let sdary = [];
    let bary = [];
    tary = dary[0];
    tary.forEach(el => {
      cary.push(el['_id']);
    })
    tary = dary[1];
    tary.forEach(el => {
      sary.push(el['_id']);
    })
    tary = dary[2];
    tary.forEach(el => {
      lary.push(el['_id']);
    })
    tary = dary[3];
    tary.forEach(el => {
      pary.push(el['_id']);
    })
    tary = dary[5];
    tary.forEach(el => {
      bary.push(el['_id']);
    })

    // let cary = dary[0];
    // let sary = dary[1];
    //lary = dary[2];
    // pary = dary[3];
    sdary = dary[4];
    // bard = dary[5];

    this.setState({ 'city_list': cary, 'state_list': sary, 'lok_list': lary, 'ppn_list': pary, 'bedroom_list': bary });


  }
*/



// WEBPACK FOOTER //
// ./src/components/deals/FilterDealsBar.js